// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2nkj2","content":"styles_content__3hun1","selectAll":"styles_selectAll__esq36"};